// Modules imports
import Login from './views/containers/Login/state';
import Dashboard from './views/containers/Dashboard/state';
import Error404 from './views/containers/Errors/404';
import ERF from './views/containers/HRAutomation/ERF/state';
import PublicAF from './views/containers/HRAutomation/PublicApplicationForm/state';
import Interviews from './views/containers/HRAutomation/Interviews/state';
import JobOffer from './views/containers/HRAutomation/JobOffer/state';
import TrainingMasterModule from './views/containers/HRAutomation/TrainingMasterModule/state';
import AvailableJob from './views/containers/HRAutomation/AvailableJob/state';
import OnboardingTrainingTracker from './views/containers/HRAutomation/OnboardingTrainingTracker/state';
import CoA from './views/containers/HRAutomation/ConfigurationofApprovers/state';
import BackgroundCheck from './views/containers/HRAutomation/BackgroundCheck/state';
import Survey from './views/containers/HRAutomation/Survey/state';
import Onboarding from './views/containers/HRAutomation/Onboarding/state';
import { WEBHRIS_OLD, PAYROLL_ROOT, HR_URL_ROOT, URL_ROOT } from './config/settings';
import PublicPage from './views/containers/PublicPage/state'

// Module Routes
export const rootRoutes = [
    ...Login.routes,
    ...Dashboard.routes,
    ...ERF.routes,
    ...PublicAF.routes,
    ...Interviews.routes,
    ...Onboarding.routes,
    ...JobOffer.routes,
    ...TrainingMasterModule.routes,
    ...AvailableJob.routes,
    ...OnboardingTrainingTracker.routes,
    ...CoA.routes,
    ...BackgroundCheck.routes,
    ...Survey.routes,
    ...PublicPage.routes,
    { component: Error404 }
]

export const sidebarRoutes = [
    {
        label: 'Maintenance',
        menuName: 'MTN',
        icon: 'fa-address-book-o',
        children: [
            {
                label: 'HR',
                menuName: 'hr',
                children: [
                    {
                        label: 'Admin Personnel',
                        showNav: true,
                        externalPath: true,
                        menuName: 'adminPersonnel',
                        path: WEBHRIS_OLD + '/adminpersonnel',
                    },
                    {
                        label: 'Announcements',
                        showNav: true,
                        externalPath: true,
                        menuName: 'announcements',
                        path: WEBHRIS_OLD + '/announcements',
                    },
                    // {
                    //     label: 'Clearance',
                    //     showNav: true,
                    //     externalPath: true,
                    //     menuName: 'clearance',
                    //     path: WEBHRIS_OLD + '/clearance',
                    // },
                    {
                        label: 'Committee',
                        showNav: true,
                        externalPath: true,
                        menuName: 'committee',
                        path: WEBHRIS_OLD + '/committee',
                    },
                    {
                        label: 'Cut-Off',
                        showNav: true,
                        externalPath: true,
                        menuName: 'cutOff',
                        path: WEBHRIS_OLD + '/cutoff',
                    },
                    {
                        label: 'Department',
                        showNav: true,
                        externalPath: true,
                        menuName: 'department',
                        path: WEBHRIS_OLD + '/department',
                    },
                    {
                        label: 'Employer',
                        showNav: true,
                        externalPath: true,
                        menuName: 'employer',
                        path: WEBHRIS_OLD + '/employer',
                    },
                    {
                        label: 'Holiday and Events',
                        showNav: true,
                        externalPath: true,
                        menuName: 'holidayAndEvents',
                        path: WEBHRIS_OLD + '/holiday',
                    },
                    {
                        label: 'Leave Credits',
                        showNav: true,
                        externalPath: true,
                        menuName: 'leaveCredits',
                        path: WEBHRIS_OLD + '/leavecredits',
                    },
                    {
                        label: 'Memo Issuance',
                        showNav: true,
                        externalPath: true,
                        menuName: 'memoIssuance',
                        path: WEBHRIS_OLD + '/memoissuance',
                    },
                    {
                        label: 'P & L',
                        showNav: true,
                        externalPath: true,
                        menuName: 'pAndL',
                        path: WEBHRIS_OLD + '/pandl',
                    },
                    {
                        label: 'Position',
                        showNav: true,
                        externalPath: true,
                        menuName: 'position',
                        path: WEBHRIS_OLD + '/position',
                    },
                    {
                        label: 'Section',
                        showNav: true,
                        externalPath: true,
                        menuName: 'section',
                        path: WEBHRIS_OLD + '/section',
                    },
                    {
                        label: 'Reminders',
                        showNav: true,
                        externalPath: true,
                        menuName: 'reminders',
                        path: WEBHRIS_OLD + '/reminders',
                    },
                ]
            },
            {
                label: 'Request',
                menuName: 'request',
                children: [
                    {
                        label: 'Leave Type',
                        showNav: true,
                        externalPath: true,
                        menuName: 'leaveType',
                        path: WEBHRIS_OLD + '/leavetypelist'
                    }
                ]
            },
            {
                label: 'ATK Settings',
                menuName: 'atkSettings',
                children: [
                    {
                        label: 'Shift',
                        showNav: true,
                        externalPath: true,
                        menuName: 'shift',
                        path: WEBHRIS_OLD + '/shift'
                    },
                ]

            }
        ]
    },
    {
        label: 'Employee 201',
        menuName: '201',
        icon: 'fa-address-card-o',
        path: WEBHRIS_OLD + '/employee201',
        externalPath: true,
        showNav: true
    },
    {
        label: 'Requests',
        menuName: 'HRIS',
        icon: 'fa-list',
        children: [
            {
                label: 'Member Requests',
                menuName: 'memberRequest',
                children: [
                    {
                        label: 'Member Leave Requests',
                        path: WEBHRIS_OLD + '/memberleaverequest',
                        menuName: 'memLeaveRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Log Requests',
                        path: WEBHRIS_OLD + '/memberlogrequest',
                        menuName: 'memLogRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Overtime Requests',
                        path: WEBHRIS_OLD + '/memberovertimerequest',
                        menuName: 'memOTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member CTO Requests',
                        path: WEBHRIS_OLD + '/memberctorequest',
                        menuName: 'memCTORequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Business Trip Requests',
                        path: WEBHRIS_OLD + '/memberbusinesstrip',
                        menuName: 'memBTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Change Shift Requests',
                        path: WEBHRIS_OLD + '/membercsrequest',
                        menuName: 'memCSRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Department Transfer Requests',
                        path: WEBHRIS_OLD + '/memberdtrequest',
                        menuName: 'memDTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Member Company Transfer Requests',
                        path: WEBHRIS_OLD + '/memberctrequest',
                        menuName: 'memCTRequest',
                        externalPath: true,
                        showNav: true
                    },
                ]
            },
            {
                label: 'My Requests',
                menuName: 'myRequest',
                children: [
                    {
                        label: 'My Leave Requests',
                        path: WEBHRIS_OLD + '/myleaverequest',
                        menuName: 'myLeaveRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Log Requests',
                        path: WEBHRIS_OLD + '/mylogrequest',
                        menuName: 'myLogRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Overtime Requests',
                        path: WEBHRIS_OLD + '/myovertimerequest',
                        menuName: 'myOTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My CTO Requests',
                        path: WEBHRIS_OLD + '/myctorequest',
                        menuName: 'myCTORequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My COE Requests',
                        path: WEBHRIS_OLD + '/dashboard',
                        menuName: 'myCOERequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Business Trip Requests',
                        path: WEBHRIS_OLD + '/mybusinesstrip',
                        menuName: 'myBTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Change Shift Requests',
                        path: WEBHRIS_OLD + '/mycsrequest',
                        menuName: 'myCSRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Department Transfer Requests',
                        path: WEBHRIS_OLD + '/mydtrequest',
                        menuName: 'myDTRequest',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'My Company Transfer Requests',
                        path: WEBHRIS_OLD + '/myctrequest',
                        menuName: 'myCTRequest',
                        externalPath: true,
                        showNav: true
                    },
                ]
            },
            {
                label: 'HR Requests',
                menuName: 'hrRequest',
                children: [
                    {
                        label: 'Leave Requests',
                        path: WEBHRIS_OLD + '/hrfiledleaverequest',
                        menuName: 'myCTRequest',
                        externalPath: true,
                        showNav: true
                    },
                ]
            }
        ]
    },
    {
        label: 'Payroll System',
        menuName: 'PP',
        icon: 'fa-list',
        path: PAYROLL_ROOT,
        externalPath: true,
        showNav: true,
        // children: [
        // {
        //     label: 'Forms',
        //     menuName: 'forms',
        //     children: [
        //         {
        //             label: 'Income Adjustment Form',
        //             path: PAYROLL_ROOT + '/IncomeAdjustment',
        //             menuName: 'incomeAdjustmentForm',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'Deduction Adjustment Form',
        //             path: PAYROLL_ROOT + '/DeductionAdjustment',
        //             menuName: 'deductionAdjustmentForm',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'Leave Encashment Form',
        //             path: PAYROLL_ROOT + '/LeaveEncashment',
        //             menuName: 'leaveEncashmentForm',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'Employee Termination Form',
        //             path: PAYROLL_ROOT + '/EmployeeTermination',
        //             menuName: 'employeeTerminationForm',
        //             externalPath: true,
        //             showNav: true
        //         },
        // 		{
        //             label: 'Bonus Compensation',
        //             path: PAYROLL_ROOT + '/BonusComputation',
        //             menuName: 'bonusComputation',
        //             externalPath: true,
        //             showNav: true
        //         },
        //     ]
        // },
        // {
        //     label: 'Payroll Register',
        //     menuName: 'payrollRegister',
        //     children: [
        // 		{
        //             label: 'Payroll Register Computation',
        //             path: PAYROLL_ROOT + '/PayrollRegister',
        //             menuName: 'payrollRegisterComputation',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'View Payslip',
        //             path: PAYROLL_ROOT + '',
        //             menuName: 'payslip',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'Export Bank Data',
        //             path: PAYROLL_ROOT + '',
        //             menuName: 'exportBankData',
        //             externalPath: true,
        //             showNav: true
        //         }
        //     ]
        // },
        // {
        //     label: 'Year End Batch Processing',
        //     menuName: 'yearEndBatchProcessing',
        //     children: [
        //         {
        //             label: 'CTC Master Record',
        //             path: PAYROLL_ROOT + '/CTCMasterRecord',
        //             menuName: 'ctcMaster',
        //             externalPath: true,
        //             showNav: true
        //         },
        //         {
        //             label: 'Alphalist Computation',
        //             path: PAYROLL_ROOT + '/AlphaComputation',
        //             menuName: 'alphaList',
        //             externalPath: true,
        //             showNav: true
        //         },
        //     ]
        // }
        // ]
    },
    {
        label: 'Timelogs',
        menuName: 'TK',
        icon: 'fa-hourglass-1',
        children: [
            {
                label: 'My Timelogs',
                path: WEBHRIS_OLD + '/mytimelogs',
                menuName: 'myTimelogs',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Member Timelogs',
                path: WEBHRIS_OLD + '/membertimelogs',
                menuName: 'memTimelogs',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Timelog Exception',
                path: WEBHRIS_OLD + '/timelogexception',
                menuName: 'timelogException',
                externalPath: true,
                showNav: true
            },
        ],
        showNav: true
    },
    {
        label: 'Reports',
        menuName: 'RPT',
        icon: 'fa-line-chart',
        children: [
            {
                label: 'HR Reports',
                menuName: 'hrReports',
                children: [
                    // {
                    //     label: 'Employee List Report',
                    //     path: PAYROLL_ROOT + '/EmployeeListReport',
                    //     menuName: 'hrEmployeeListReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Tardiness Report',
                    //     path: PAYROLL_ROOT + '/TardinessReport',
                    //     menuName: 'hrTardinessReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Undertime Report',
                    //     path: PAYROLL_ROOT + '/UndertimeReport',
                    //     menuName: 'hrUndertimeReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Overtime Reports',
                    //     path: PAYROLL_ROOT + '/OvertimeReport',
                    //     menuName: 'hrOvertimeReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Absences Report',
                    //     path: PAYROLL_ROOT + '/Absences',
                    //     menuName: 'hrAbsencesReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Employee Leave Report',
                    //     path: PAYROLL_ROOT + '/EmployeeLeaveReport',
                    //     menuName: 'hrELReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Timecard Summary Report',
                    //     path: PAYROLL_ROOT + '/TimecardSummary',
                    //     menuName: 'hrTSReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Bankslip',
                    //     path: PAYROLL_ROOT + '',
                    //     menuName: 'hrBankslipReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Payslip',
                    //     path: PAYROLL_ROOT + '',
                    //     menuName: 'hrPayslipReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: '13th Month Register',
                    //     path: PAYROLL_ROOT + '',
                    //     menuName: 'hr13thMonthRegister',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Deductions Report',
                    //     path: PAYROLL_ROOT + '/DeductionReport',
                    //     menuName: 'hrDeductionReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Payroll Summary Report',
                    //     path: PAYROLL_ROOT + '/PayrollSummary',
                    //     menuName: 'hrPSReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    // {
                    //     label: 'Payroll Register Report',
                    //     path: PAYROLL_ROOT + '/PayrollRegisterReport',
                    //     menuName: 'hrPRReport',
                    //     externalPath: true,
                    //     showNav: true
                    // },
                    {
                        label: 'Company Transfer Reports',
                        path: WEBHRIS_OLD + '/HRCTReports',
                        menuName: 'hrCTReport',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Department Transfer Reports',
                        path: WEBHRIS_OLD + '/HRDTReports',
                        menuName: 'hrDTReport',
                        externalPath: true,
                        showNav: true
                    },
                ],
                showNav: true
            },
            // {
            //     label: 'Payroll Reports',
            //     menuName: 'payrollReports',
            //     children: [
            //         {
            //             label: 'Individual Earnings Report',
            //             path: PAYROLL_ROOT + '/IndividualEarnings',
            //             menuName: 'payrollIEReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'SSS Loan Payments Report',
            //             path: PAYROLL_ROOT + '/SSSLoanPaymentReport',
            //             menuName: 'payrollSLPReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //     ],
            //     showNav: true
            // },
            // {
            //     label: 'Government Reports',
            //     menuName: 'governmentReports',
            //     children: [
            //         {
            //             label: 'Withholding Tax Report',
            //             path: PAYROLL_ROOT + '/WithholdingTaxReport',
            //             menuName: 'govtWTReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Withholding Tax Quarterly Report',
            //             path: PAYROLL_ROOT + '/WithholdingTaxQuarterlyReport',
            //             menuName: 'govtWTQReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Alpha List Report',
            //             path: PAYROLL_ROOT + '/AlphaListReport',
            //             menuName: 'govtALReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Withholding Tax Annual Report',
            //             path: PAYROLL_ROOT + '/WithholdingTaxAnnualReport',
            //             menuName: 'govtWTAReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'HDMF Report',
            //             path: PAYROLL_ROOT + '/HDMFReport',
            //             menuName: 'govtHDMFReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'SSS Report',
            //             path: PAYROLL_ROOT + '/SSSReport',
            //             menuName: 'govtSSSReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Philhealth Report',
            //             path: PAYROLL_ROOT + '/PHReport',
            //             menuName: 'govtPhilhealthReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Withholding Tax BIR Form No. 2316',
            //             path: PAYROLL_ROOT + '/BIRF2316Report',
            //             menuName: 'govtWTBIRForm2316',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'SSS R-1A Employment Report',
            //             path: PAYROLL_ROOT + '/SSSR1AReport',
            //             menuName: 'govtSSSR1AEmploymentReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'SSS Salary Loan Quarterly Report',
            //             path: PAYROLL_ROOT + '',
            //             menuName: 'govtSSSSLQReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Pag-Ibig Loan Payment Report',
            //             path: PAYROLL_ROOT + '',
            //             menuName: 'govtPagibigLPReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Phil-Health ER2',
            //             path: PAYROLL_ROOT + '/PER2',
            //             menuName: 'govtPhilhealthER2',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'SSS R-3 Contribution Collection List Report',
            //             path: PAYROLL_ROOT + '',
            //             menuName: 'govtSSSR3CCLReport',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'PhilHealth RF-1 Report',
            //             path: PAYROLL_ROOT + '',
            //             menuName: 'govtPhilhealthRF1Report',
            //             externalPath: true,
            //             showNav: true
            //         },
            //     ],
            //     showNav: true
            // },
            // {
            //     label: 'Certificates',
            //     menuName: 'certificates',
            //     children: [
            //         {
            //             label: 'Employment Certificate',
            //             path: PAYROLL_ROOT + '/EmploymentCertificate',
            //             menuName: 'certEmploymentCertificate',
            //             externalPath: true,
            //             showNav: true
            //         },
            //         {
            //             label: 'Government Certificate',
            //             path: PAYROLL_ROOT + '',
            //             menuName: 'certGovernmentCertificate',
            //             externalPath: true,
            //             showNav: true
            //         },
            //     ],
            //     showNav: true
            // },
        ],
        showNav: true
    },
    // {
    //     label: 'Data Exchange',
    //     menuName: 'DE',
    //     icon: 'fa-list',
    //     children: [
    //         {
    //             label: 'Employee Class',
    //             menuName: 'employeeClass',
    //             path: PAYROLL_ROOT + '/EmployeeClassData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Holiday Calendar',
    //             menuName: 'holidayCalendar',
    //             path: PAYROLL_ROOT + '/HolidayCalendarData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Shift Schedule',
    //             menuName: 'shiftSchedMaster',
    //             path: PAYROLL_ROOT + '/ShiftScheduleData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Department',
    //             menuName: 'departmentMaster',
    //             path: PAYROLL_ROOT + '/DepartmentData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Section',
    //             menuName: 'sectionMaster',
    //             path: PAYROLL_ROOT + '/SectionData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Payroll Batch',
    //             menuName: 'payrollBatchMaster',
    //             path: PAYROLL_ROOT + '/PayrollBatchData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Tax Table',
    //             menuName: 'taxTable',
    //             path: PAYROLL_ROOT + '/TaxTableData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Philhealth',
    //             menuName: 'philhealthTable',
    //             path: PAYROLL_ROOT + '/PhilhealthData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'SSS',
    //             menuName: 'sssTable',
    //             path: PAYROLL_ROOT + '/SSSData',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Job Position',
    //             menuName: 'jobPositionMaster',
    //             path: PAYROLL_ROOT + '/DataExchange/JobPosition',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Allowance Type',
    //             menuName: 'allowanceType',
    //             path: PAYROLL_ROOT + '/DataExchange/AllowanceType',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'COA',
    //             menuName: 'coaMasterRecord',
    //             path: PAYROLL_ROOT + '/DataExchange/COA',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'CTC',
    //             menuName: 'ctcMasterRecord',
    //             path: PAYROLL_ROOT + '/DataExchange/CTC',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Deduction Type',
    //             menuName: 'deductionType',
    //             path: PAYROLL_ROOT + '/DataExchange/DeductionType',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Income Type',
    //             menuName: 'incomeType',
    //             path: PAYROLL_ROOT + '/DataExchange/IncomeType',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Leave Type',
    //             menuName: 'leaveType',
    //             path: PAYROLL_ROOT + '/DataExchange/LeaveType',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Period',
    //             menuName: 'periodMaster',
    //             path: PAYROLL_ROOT + '/DataExchange/Period',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Salary Grade',
    //             menuName: 'salaryGrade',
    //             path: PAYROLL_ROOT + '/DataExchange/SalaryGrade',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Employee 201',
    //             menuName: '',
    //             path: PAYROLL_ROOT + '/Employee201Data',
    //             externalPath: true,
    //             showNav: true
    //         },
    //         {
    //             label: 'Timecard',
    //             menuName: '',
    //             path: PAYROLL_ROOT + '/TimecardTransaction',
    //             externalPath: true,
    //             showNav: true
    //         },
    //     ],
    //     showNav: true
    // },
    {
        label: 'HR Recruitment',
        menuName: 'HRRA',
        icon: 'fa-user-plus',
        children: [
            {
                label: 'Employee Request Form',
                menuName: 'hrraEmployeeRequestForm',
                path: HR_URL_ROOT + '/HRAutomation/ERF',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Application Form',
                menuName: 'hrraPublicApplicationForm',
                path: HR_URL_ROOT + '/HRAutomation/ApplicationForm',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Interviews',
                menuName: 'hrraInterviews',
                path: HR_URL_ROOT + '/HRAutomation/Interviews',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Background Check',
                menuName: 'hrraBackgroundCheck',
                path: HR_URL_ROOT + '/HRAutomation/BackgroundCheck',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Job Offer',
                menuName: 'hrraJobOffer',
                path: HR_URL_ROOT + '/HRAutomation/JobOffer',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Onboarding',
                menuName: 'hrraOnboarding',
                path: HR_URL_ROOT + '/HRAutomation/Onboarding',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Onboarding Training Tracker',
                menuName: 'hrraOnboardingTrainingTracker',
                path: HR_URL_ROOT + '/HRAutomation/OnboardingTrainingTracker',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Configuration of Approvers',
                menuName: 'hrraConfigurationOfApprovers',
                path: HR_URL_ROOT + '/HRAutomation/ConfigurationofApprovers',
                externalPath: true,
                showNav: true
            },
            {
                label: 'Master',
                menuName: 'master',
                children: [
                    {
                        label: 'Trainings',
                        menuName: 'hrraTrainingMasterModule',
                        path: HR_URL_ROOT + '/HRAutomation/TrainingMasterModule',
                        externalPath: true,
                        showNav: true
                    },
                    {
                        label: 'Jobs',
                        menuName: 'hrraAvailableJobs',
                        path: HR_URL_ROOT + '/HRAutomation/AvailableJobs',
                        externalPath: true,
                        showNav: true
                    },
                ],
                showNav: true
            },
        ],
    },
    {
        label: 'Application Details',
        menuName: 'PUBLIC',
        icon: 'fa-user-plus',
        path: URL_ROOT + '/applicantdetails',
        externalPath: true,
        showNav: true,
        public: true,
    },
    {
        label: 'Application Status',
        menuName: 'PUBLIC',
        icon: 'fa-user-plus',
        path: URL_ROOT + '/applicantstatus',
        externalPath: true,
        showNav: true,
        public: true
    },
];

